import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { AnnouncementBar } from './components/AnnouncementBar';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel } from './components/MetaPixel';
const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/4uX3G3wUEjM6S8x4n4MirU/MOCKUP_PRINCIPAL.png';
const CHECKOUT_ORIGIN = 'https://functional-fitness-365.impultienda.ar';

// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // English by default. translate="no" stops browser auto-translation from
    // rewriting the DOM, which is a known cause of React crashes.
    document.documentElement.lang = 'en';
    document.documentElement.setAttribute('translate', 'no');
    document.title = 'Functional Fitness 365™ — Your entire year of functional classes, ready';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'en'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'English'
    });
    ensureMeta({
      name: 'description',
      content: 'Functional Fitness 365: 6 volumes, 365 ready-to-teach sessions and 5 strategic bonuses. Your entire year of functional fitness classes, ready today for $17 USD. Pay in your local currency.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    ensureMeta({
      name: 'theme-color',
      content: '#020617'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: HERO_MOCKUP,
      fetchpriority: 'high'
    });
    // Warm up the checkout connection so CTA clicks navigate instantly.
    ensureLink({
      rel: 'dns-prefetch',
      href: CHECKOUT_ORIGIN
    });
    ensureLink({
      rel: 'preconnect',
      href: CHECKOUT_ORIGIN,
      crossorigin: ''
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://connect.facebook.net'
    });
  }, []);
  return <div lang="en" translate="no" className="notranslate min-h-screen w-full bg-slate-950 text-slate-300 selection:bg-blue-600 selection:text-white" data-id="element-0" data-mp="1w211amro7izo">
      <MetaPixel data-id="element-1" data-mp="1m4ms9882twhe" />
      <SocialProofPopup data-id="element-2" data-mp="1m44n1m3fs7xc" />
      <ExitIntentModal data-id="element-3" data-mp="1m3cw4oksayde" />
      <AnnouncementBar data-id="element-4" data-mp="6ofcokl3vndc" />
      <main data-id="element-5" data-mp="6nw3ptdfo9bg">
        <Hero data-id="element-6" data-mp="6ncnch3flszj" />
        <SocialProof data-id="element-7" data-mp="6muiiw2pe6g0" />
        <Testimonials1 data-id="element-8" data-mp="6qif643g38yy" />
        <Problem data-id="element-9" data-mp="apr6l2b0iurc" />
        <ProductTomos data-id="element-10" data-mp="aq9bsofnkjbe" />
        <Bonuses data-id="element-11" data-mp="aqsh95o49f8j" />
        <UrgencyCounter data-id="element-12" data-mp="arc3gyksupsd" />
        <Pricing data-id="element-13" data-mp="qx5fjw6rik9f" />
        <Testimonials2 data-id="element-14" data-mp="qxnmbmr1wgvl" />
        <Guarantee data-id="element-15" data-mp="qy71ivpbgr5x" />
        <FAQ data-id="element-16" data-mp="qygjpx44du12" />
        <CostOfNotHaving data-id="element-17" data-mp="qz8h9dha21tz" />
        <FinalCTA data-id="element-18" data-mp="m6p1qaz14wmj" />
      </main>
      <Footer data-id="element-19" data-mp="m5dxyb5l3ovf" />
      <StickyMobileCTA data-id="element-20" data-mp="m4uid13epckk" />
    </div>;
}